import CorrectNumbers from "../../components/ClassOne/English/CorrectNumbers";
import GenderConversionActivity from "../../components/ClassOne/English/GenderConversion";
import GenderNumber from "../../components/ClassOne/English/GenderNumber";
import GenderActivity from "../../components/ClassOne/English/IdentifyGender";
import SingularPlural from "../../components/ClassOne/English/SingularPlural";


// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-one/english/gender-numbers/identify-gender", title: "Identify the Gender", component: GenderActivity },
    { url: "/class-one/english/gender-numbers/gender-conversion", title: "Conversion of Gender", component: GenderConversionActivity },
    { url: "/class-one/english/gender-numbers/singular-plural", title: "Singular to Plural", component: SingularPlural },
    { url: "/class-one/english/gender-numbers/correct-sentence", title: "Choose Correct Sentence", component: CorrectNumbers },
];


export default topics;